import { WorkflowOverlayComponent } from 'commons/components';
import {
    CustomNotificationFormCard,
    CustomNotificationFormCardContent,
    CustomNotificationFormContentWrapper,
} from 'modules/settings/components/custom-notifications/custom-notification-form-layout/custom-notification-form-layout.style';

export interface CustomNotificationFormLayoutProps extends React.PropsWithChildren {
    headerTitle: string;
    footer?: React.ReactElement[];
    visible?: boolean;
    loading?: boolean;
    onClose: VoidFunction;
}

export const CustomNotificationFormLayout: React.FC<CustomNotificationFormLayoutProps> = ({
    headerTitle,
    footer,
    visible = true,
    loading = false,
    onClose,
    children,
}) => (
    <WorkflowOverlayComponent
        visible={visible}
        loading={loading}
        headerTitle={headerTitle}
        onClose={onClose}
        className="show-header"
        footer={footer}
    >
        <CustomNotificationFormContentWrapper>
            <CustomNotificationFormCard>
                <CustomNotificationFormCardContent>{children}</CustomNotificationFormCardContent>
            </CustomNotificationFormCard>
        </CustomNotificationFormContentWrapper>
    </WorkflowOverlayComponent>
);
